export const enum WorkInstruction {
  NO_WORK_INSTRUCTION = 0,
  PARALLEL_SORTING = 1
}
